//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// img
import Info from "../../../assets/img/icon/icon_info.svg";

// responsive
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// 모달
import DefaultPop from "../../../component/popup/DefaultModal";
import BasicBtn from "../../../component/button/BasicBtn";
import modalScroll from "../../../utils/ModalScroll";

export default function Login({ setIdModal, setPwModal }) {
    // 로그인 창 액티브 스타일
    const [istext1, setIsText1] = useState(false);
    const [istext2, setIsText2] = useState(false);

    return (
        <Container>
            <LoginSection>
                <Title>LOGIN</Title>
                <SubTitle>
                    아직 회원이 아니신가요? <SignText to={`/signup`}>회원가입하기</SignText>
                </SubTitle>

                <LoginForm>
                    <InputList active={istext1.length > 0}>
                        <InputBox
                            type="text"
                            placeholder="아이디를 입력해주세요."
                            onChange={(e) => {
                                setIsText1(e.target.value);
                            }}
                            required
                        />
                    </InputList>
                    <InputList active={istext2.length > 0}>
                        <InputBox
                            type="password"
                            placeholder="비밀번호를 입력해주세요."
                            onChange={(e) => {
                                setIsText2(e.target.value);
                            }}
                            required
                        />
                    </InputList>
                </LoginForm>

                {/* 아이디 , 비번 일치하지 않을 때 */}
                {/* <NotText>
                        <img src={Info} alt="아이콘" />
                        아이디 또는 비밀번호가 일치하지 않습니다.
                    </NotText> */}

                <LoginBtnWrap>
                    <BasicBtn text="Login" />
                </LoginBtnWrap>

                <FindTextWrap>
                    <FindLogin
                        onClick={() => {
                            setPwModal(true);
                        }}
                    >
                        비밀번호찾기
                    </FindLogin>
                </FindTextWrap>
            </LoginSection>
        </Container>
    );
}

const Container = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;
const LoginSection = styled.div`
    width: calc(100vw * (480 / 1920));
    margin: calc(100vw * (283 / 1920)) auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (480 / 1300));
        margin: calc(100vw * (283 / 1300)) auto;
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin: ${M(168)} auto ${M(242)};
    }
`;
const Title = styled.h2`
    text-align: center;
    font-family: "Pop-EL";
    font-size: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(30)};
    }
`;
const SubTitle = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: calc(100vw * (10 / 1920));

    font-family: "Noto-M";
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (10 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(15)};
        font-size: ${M(14)};
    }
`;
const SignText = styled(Link)`
    margin-left: calc(100vw * (5 / 1920));

    color: var(--main-color);
    border-bottom: 1px solid var(--main-color);

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-left: ${M(5)};
    }
`;
const LoginForm = styled.div`
    margin-top: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(30)};
    }
`;

const NotText = styled.p`
    margin-top: calc(100vw * (20 / 1920));
    font-size: calc(100vw * (15 / 1920));

    color: #ef0000;

    & img {
        margin-right: calc(100vw * (5 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
        font-size: calc(100vw * (15 / 1300));

        & img {
            margin-right: calc(100vw * (5 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(13)};
        font-size: ${M(13)};

        & img {
            margin-right: ${M(5)};
        }
    }
`;
const LoginBtnWrap = styled.button`
    width: 100%;
    margin-top: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(35)};
    }
`;
const FindTextWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: calc(100vw * (34 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (34 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(30)};
    }
`;
const FindLogin = styled.span`
    font-size: calc(100vw * (15 / 1920));
    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const InputList = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: calc(100vw * (50 / 1920));
    border-radius: 4px;
    background-color: #fafafa;
    overflow: hidden;
    padding: calc(100vw * (12 / 1920));
    margin-top: calc(100vw * (25 / 1920));

    ${({ active }) => {
        return active ? `border: 1px solid var(--main-color);` : `border: 1px solid #FAFAFA;`;
    }}

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (50 / 1300));
        padding: calc(100vw * (12 / 1300));
        margin-top: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(45)};
        padding: ${M(12)} ${M(15)};
        margin-top: ${M(15)};
    }
`;
const InputBox = styled.input`
    width: 100%;
    height: 100%;
    font-size: calc(100vw * (15 / 1920));
    color: #222222;

    &::placeholder {
        color: #dddddd;
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
